import {useMutation} from "@apollo/client";
import {useState} from "react";
import {toast} from "react-hot-toast";

import {Alert} from "@/components/alert/Alert.tsx";
import Button from "@/components/button/Button.tsx";
import {DeleteActionDialog} from "@/components/deleteActionDialog/DeleteActionDialog.tsx";
import {QuickActionsBar} from "@/components/quickActionsBar/QuickActionsBar.tsx";
import {
  GQL_MAINTENANCE_SCHEDULES_LIST,
  GQL_UNLINK_SERVICE_FROM_MAINTENANCE_SCHEDULE,
} from "@/lib/queries/maintenance.ts";
import {GraphQLResponse, ResponseStatus} from "@/lib/types/common.ts";

interface DisconnectScheduleButtonProps {
  scheduleId: number;
  scheduleName: string;
  checkId: number;
}

export const LinkedSchedulesActions = ({scheduleId, scheduleName, checkId}: DisconnectScheduleButtonProps) => {
  const [showConfirmation, setShowConfirmation] = useState(false);

  const [unlinkService, {loading}] = useMutation<GraphQLResponse<null>>(GQL_UNLINK_SERVICE_FROM_MAINTENANCE_SCHEDULE, {
    refetchQueries: [GQL_MAINTENANCE_SCHEDULES_LIST],
  });

  const handleConfirmDisconnect = async () => {
    const response = await unlinkService({
      variables: {
        scheduleId,
        serviceId: checkId,
      },
    });
    if (response?.data?.response?.status === ResponseStatus.SUCCESS) {
      toast.success("Check unlinked from Schedule");
      setShowConfirmation(false);
    }
  };

  return (
    <>
      <QuickActionsBar
        id={`disconnect-schedule-${scheduleId}`}
        actions={[
          <Button variant={"secondary"} size={"small"} onClick={() => setShowConfirmation(true)}>
            Disconnect
          </Button>,
        ]}
      />
      <DeleteActionDialog
        show={showConfirmation}
        title="Disconnect Schedule"
        loading={loading}
        onCancel={() => setShowConfirmation(false)}
        onConfirm={handleConfirmDisconnect}
      >
        <Alert variant={"maintenance"} className="mb-3">
          Disconnecting this Schedule may cause the Check to resume normal operations.
        </Alert>
        <div>
          Are you sure you want to disconnect the Maintenance Schedule{" "}
          <span className={"pulseTextBodyBold"}>{scheduleName}</span> from this Check? This will not impact the Schedule
          itself and can be linked again.
        </div>
      </DeleteActionDialog>
    </>
  );
};
